import { render, staticRenderFns } from "./addMessage.vue?vue&type=template&id=3e760d05&"
import script from "./addMessage.vue?vue&type=script&lang=js&"
export * from "./addMessage.vue?vue&type=script&lang=js&"
import style0 from "./addMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports